var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-page-container"},[(_vm.isLoading)?[_c('Loading')]:[_c(_vm.evaluateComponentToRender(),{tag:"component",attrs:{"subSectionData":_vm.subSectionData}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }